import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	height: 90px;
	padding: 0px 40px;
`;

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const ContainerButton = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;
